module.exports = __webpack_public_path__ + "img/box2.ae912086.png";